import keysToConstants from 'js/lib/keysToConstants';

// REF https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/scala/org/coursera/payment/PaymentProcessorId.scala
const exported = keysToConstants([
  'appleInapp',
  'appleInappSandbox',
  'braintree',
  'braintreeSandbox',
  'razorpay',
  'razorpaySandbox',
  'stripe',
  'stripeSandbox',
  'stripeConsumer',
  'stripeConsumerSandbox',
  'coursera',
  'financialAid',
  'paypal',
  'paypalSandbox',
  'zeroDollar',
  'mockPaymentProcessor',
  'stripeBvConsumer',
  'stripeBvConsumerSandbox',
  'razorpayChargeAtWill',
  'razorpayChargeAtWillSandbox',
  'dlocal',
  'dlocalSandbox',
]);

export const {
  appleInapp,
  appleInappSandbox,
  braintree,
  braintreeSandbox,
  razorpay,
  razorpaySandbox,
  stripe,
  stripeSandbox,
  stripeConsumer,
  stripeConsumerSandbox,
  coursera,
  financialAid,
  paypal,
  paypalSandbox,
  zeroDollar,
  mockPaymentProcessor,
  stripeBvConsumer,
  stripeBvConsumerSandbox,
  razorpayChargeAtWill,
  razorpayChargeAtWillSandbox,
  dlocal,
  dlocalSandbox,
} = exported;

export default exported;

export type PaymentProcessorType = (typeof exported)[keyof typeof exported];
